import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconClock } from '@picsart/design-system/foundation/icons/IconClock';
import { IconCross } from '@picsart/design-system/foundation/icons/IconCross';
import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './styles';
import type { SearchRecentProps } from './types';

/**
 * The idle state's content: what you searched for last time. Replaces a blank
 * screen with the one thing a returning user is most likely to want.
 */
const SearchRecent = ({
  terms,
  onSelect,
  onRemove,
  onClearAll,
}: SearchRecentProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  if (!terms.length) return null;

  return (
    <div className={classes.root} data-testid="search-recent">
      <div className={classes.header}>
        <span className={classes.title}>{translate('Recent searches')}</span>
        <InlineButton
          size="small"
          isWithoutBorder
          isWithoutBackground
          onClick={onClearAll}
          dataTestId="search-recent-clear-all"
        >
          {translate('Clear all')}
        </InlineButton>
      </div>
      <ul className={classes.list}>
        {terms.map((term) => (
          <li key={term} className={classes.item}>
            <button
              type="button"
              className={classes.term}
              onClick={() => onSelect(term)}
              data-testid={`search-recent-term-${term}`}
            >
              <IconClock className={classes.clockIcon} fill="currentColor" />
              <span className={classes.termText}>{term}</span>
            </button>
            <InlineButton
              size="small"
              centerIcon={IconCross}
              className={classes.removeButton}
              isWithoutBorder
              isWithoutBackground
              onClick={() => onRemove(term)}
              aria-label={translate('Remove')}
              dataTestId={`search-recent-remove-${term}`}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchRecent;
